let zh_en = {
    '待办事项':'Todo',
    '我的申请':'Apply',
    '进行中':'Doing',
    '已完成':'Done',
    '抄送':'CC',
    '我的事务':'My Matters',
    '我的收藏':'My Collection',
    '服务对象':'Service Object',
    '服务场景':'Service Scene',
    '服务部门':'Service DepartMent',
    '服务类别':'Service Category',
    '全部':'All',
    '网站首页':'Home',
    '服务中心':'Apps',
    '个人中心':'Personal',
    '推荐服务':'Recommended Services',
    '热门服务':'Popular Services',
    '事项':'Name',
    '更新时间':'Update Time',
    '步骤':'Now Step',
    '当前状态':'Now Status',
    '流水':'Entry',
    '进度':'Speed',
    '你好':'Nice Today',
    '退出':'Logout',
    '网上服务大厅欢迎您':'Welcome To Online Office Hall',
    '一站式':'One-Stop',
    '全天候':'All-Day',
    '零距离':'Zero-distance',
    '任务名':"Task's Name",
    '状态':'Status',
    '办理时间':'Assigned Time',
    '办理用户':'Assigned User',
    '需要您审核或存草稿的所有事项':'All matters that requires you to review or save the draft',
    '您申请或存草稿的所有事项':'All matters you apply for or save in draft',
    '所有进行中的事项':'All ongoing matters',
    '所有已完成的事项':'All the things that have been done',
    '所有抄送您的事项':'All carbon copies need you read',
    '只看未读':'Just See Unread',
    '查看全部':'View All',
    '标记为已读':'Marked as read',
    '搜索您想查找的事宜':'Search things above your input'
}

//翻译相同的近义词
const maps = {
    '标签#服务分类#服务类别':'服务类别',
    '待办事项#我的待办#待办':'待办事项',
    '收藏的应用#收藏夹':'我的收藏'
}

for(let i in maps){
    let keys= i.split('#');
    let v_key = maps[i];
    for(let j in keys){
        zh_en[keys[j]] = zh_en[v_key]
    }
}

export default {
    zh_en
}


// WEBPACK FOOTER //
// ./src/store/modules/zh_en.js